export default __webpack_public_path__ + "static/media/tomato.3b9aecbf.jpeg";